<template>
  <header id="page-header">
    <div class="content-header">
      <div>
        <a class="link-fx font-size-lg text-dual" href="/">
          <span class="font-w700 text-dual">ARX</span
          ><span class="font-w300">editor</span>
        </a>
      </div>
      <div class="d-flex align-items-center">
        <button
          type="button"
          class="btn btn-sm btn-dual"
          data-toggle="layout"
          data-action="side_overlay_toggle"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>
    </div>
    <div id="page-header-loader" class="overlay-header bg-white">
      <div class="content-header">
        <div class="w-100 text-center">
          <i class="fa fa-fw fa-2x fa-sun fa-spin"></i>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style scoped></style>
